import type { ReactNode } from 'react';

/** One titled group inside the panel: spacing does the grouping, not boxes. */
export function PanelSection({
  title,
  children,
  labelFor,
}: {
  title: string;
  children: ReactNode;
  /** When the section is one field, its title is that field's label. */
  labelFor?: string;
}) {
  return (
    <div className='space-y-3'>
      {labelFor ? (
        <label
          htmlFor={labelFor}
          className='block text-sm font-semibold text-foreground'
        >
          {title}
        </label>
      ) : (
        <h2 className='text-sm font-semibold text-foreground'>{title}</h2>
      )}
      {children}
    </div>
  );
}
